import type { SupportedLocale } from "../locales/catalog-registry";

/** **`localStorage`** key for persisted UI locale (**`DD-SRS-F-TRAINING-QUIZ.17`** demo wiring). */
export const QUIZ_UI_LOCALE_STORAGE_KEY = "quiz_ui_locale";

/**
 * Reads a previously stored UI locale tag, if valid.
 *
 * @returns Supported tag or **`null`** when unset or unreadable.
 */
export function readStoredLocale(): SupportedLocale | null {
  if (typeof localStorage === "undefined") {
    return null;
  }
  try {
    const v = localStorage.getItem(QUIZ_UI_LOCALE_STORAGE_KEY);
    if (v === "en" || v === "de" || v === "fr" || v === "da" || v === "uk") {
      return v;
    }
  } catch {
    return null;
  }
  return null;
}

/**
 * Persists UI locale for the next full load.
 *
 * @param locale - Locale to store.
 */
export function writeStoredLocale(locale: SupportedLocale): void {
  if (typeof localStorage === "undefined") {
    return;
  }
  try {
    localStorage.setItem(QUIZ_UI_LOCALE_STORAGE_KEY, locale);
  } catch {
    /* ignore quota or privacy mode */
  }
}
